export const EcommerceChangesPeriod = {
    MonthOverMonth: "mom",
    QuoterOverQuoter: "qoq",
    YearOverYear: "yoy",
} as const;

export type EcommerceChangesPeriod = (typeof EcommerceChangesPeriod)[keyof typeof EcommerceChangesPeriod];

export default EcommerceChangesPeriod;
